// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MessageProcessorBase } from './MessageProcessorBase';
import { TradingSignalRequestMessage } from '../Messages/TradingSignalRequestMessage';
export class TradingSignalRequestMessageProcessor extends MessageProcessorBase {
    decode(fieldSet) {
        const message = new TradingSignalRequestMessage(fieldSet);
        return [message];
    }
}
